module.exports = __webpack_public_path__ + "img/xarani-nobg.77465963.png";